import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { CampaignType } from '../../types/Campaign.js';
import '../../types/filters.js';
import '../../types/product.js';
import '../../types/RewardAmountType.js';
import { getImageAssetUrl } from '../../utils/assetUtils.js';
import { formatMoney } from '../../utils/stringUtils.js';
import { cn } from '../../lib/utils.js';

// Default colors for reward pills (matching brandclub theme defaults)
// Colors from packages/common-ui/src/colors/brandclubColors.ts
const PILL_COLORS = {
    [CampaignType.DailyDealsRewardCampaign]: {
        bg: 'rgba(236, 121, 46, 0.3)',
        text: 'rgb(236, 121, 46)', // orange_EC792E
    },
    [CampaignType.PurchaseRewardCampaign]: {
        bg: 'rgba(162, 34, 114, 0.3)',
        text: 'rgb(162, 34, 114)', // magenta_A22272
    },
    [CampaignType.AffiliateRewardCampaign]: {
        bg: 'rgba(22, 148, 155, 0.2)',
        text: 'rgb(22, 148, 155)', // teal_16949B
    },
    [CampaignType.ContentRewardCampaign]: {
        bg: 'rgba(162, 34, 114, 0.3)',
        text: 'rgb(162, 34, 114)', // magenta_A22272
    },
    [CampaignType.SurveyRewardCampaign]: {
        bg: 'rgba(162, 34, 114, 0.3)',
        text: 'rgb(162, 34, 114)', // magenta_A22272
    },
};
// Get config by reward campaign type
const getConfigByRewardCampaignType = (rewardCampaignType) => {
    const colors = PILL_COLORS[rewardCampaignType] || { bg: '#6B7280', text: '#FFFFFF' };
    switch (rewardCampaignType) {
        case CampaignType.DailyDealsRewardCampaign:
            return {
                iconImgProps: {
                    src: getImageAssetUrl('instant-reward-icon.webp'),
                    alt: 'instant-reward-icon',
                },
                rewardTypeDisplay: 'instant',
                colors,
            };
        case CampaignType.PurchaseRewardCampaign:
            return {
                iconImgProps: {
                    src: getImageAssetUrl('purchase-reward-icon.webp'),
                    alt: 'purchase-reward-icon',
                },
                rewardTypeDisplay: 'purchase',
                colors,
            };
        case CampaignType.AffiliateRewardCampaign:
            return {
                iconImgProps: {
                    src: getImageAssetUrl('affiliate-reward-icon.webp'),
                    alt: 'affiliate-reward-icon',
                },
                rewardTypeDisplay: '',
                colors,
            };
        case CampaignType.ContentRewardCampaign:
            return {
                iconImgProps: {
                    src: getImageAssetUrl('content-reward-icon.webp'),
                    alt: 'content-reward-icon',
                },
                rewardTypeDisplay: '',
                colors,
            };
        case CampaignType.SurveyRewardCampaign:
            return {
                iconImgProps: {
                    src: getImageAssetUrl('survey-reward-icon.webp'),
                    alt: 'survey-reward-icon',
                },
                rewardTypeDisplay: '',
                colors,
            };
        default:
            return {
                iconImgProps: {
                    src: undefined,
                    alt: 'affiliate-reward-icon',
                },
                rewardTypeDisplay: '',
                colors,
            };
    }
};
const ConciergeRewardPillWithText = ({ rewardAmount, rewardCampaignType, rewardPercent, rewardPercentText, rewardPercentTextOverride, containerStyle: containerStyleOverride = {}, pillContainerStyle = {}, baseFontSize = 14, onPillClick, className, customPillText, }) => {
    const { iconImgProps, rewardTypeDisplay, colors } = getConfigByRewardCampaignType(rewardCampaignType);
    const restIconImgProps = __rest(iconImgProps, []);
    const pillDefaultPadding = {
        paddingTop: `${baseFontSize / 3}px`,
        paddingLeft: `${baseFontSize * 0.95}px`,
        paddingBottom: `${baseFontSize / 3}px`,
        paddingRight: `${baseFontSize * 0.95}px`,
    };
    const subfixText = rewardPercentTextOverride
        ? rewardPercentTextOverride
        : rewardPercent
            ? Math.round(rewardPercent) + '% ' + (rewardPercentText !== null && rewardPercentText !== void 0 ? rewardPercentText : `${rewardTypeDisplay} reward`)
            : null;
    const pillText = customPillText !== null && customPillText !== void 0 ? customPillText : formatMoney(rewardAmount);
    return (jsxs("div", Object.assign({ className: cn('tw:flex tw:items-center tw:overflow-hidden', 'tw:**:mix-blend-normal', className), style: Object.assign({ visibility: rewardAmount || customPillText ? 'visible' : 'hidden', columnGap: '7px' }, containerStyleOverride) }, { children: [jsx("div", Object.assign({ className: "tw:rounded-full tw:bg-white tw:flex" }, { children: jsxs("div", Object.assign({ className: cn('tw:whitespace-nowrap tw:rounded-[25px] tw:text-xs tw:font-semibold', 'tw:tracking-normal tw:flex tw:items-center tw:font-inherit'), style: Object.assign(Object.assign(Object.assign({ backgroundColor: colors.bg, color: colors.text, borderRadius: '25px' }, pillDefaultPadding), pillContainerStyle), { cursor: onPillClick ? 'pointer' : 'default' }), onClick: onPillClick }, { children: [iconImgProps.src && !customPillText ? (jsx("img", Object.assign({}, restIconImgProps, { className: "tw:object-contain tw:align-middle", style: {
                                maxWidth: `${baseFontSize}px`,
                                maxHeight: `${baseFontSize}px`,
                                marginRight: `${baseFontSize * 0.416}px`,
                            } }))) : null, jsx("span", Object.assign({ className: "tw:leading-[1.3em] tw:m-0 tw:p-0" }, { children: pillText }))] })) })), subfixText ? (jsx("div", Object.assign({ className: cn('tw:text-foreground tw:text-xs tw:font-semibold', 'tw:tracking-[0.24px] tw:whitespace-nowrap', 'tw:text-ellipsis tw:overflow-hidden tw:font-inherit') }, { children: subfixText }))) : null] })));
};

export { ConciergeRewardPillWithText };
//# sourceMappingURL=ConciergeRewardPillWithText.js.map
